import MdContent from "./MdContent"

const MdContentPlugin = {
  install(app) {
    app.component(MdContent.name, MdContent)
  },
}

export default MdContentPlugin
